import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { Body, Header, Main } from '../NecttosComp/Layout/Layout';
import { FiChevronDown, FiChevronUp } from 'react-icons/fi';
import documentationData from './DocumentationData.json';

function DocumentationComponent({ title, questionsTitle, onClick }) {
	const questions = documentationData[questionsTitle] || [];
	const [expanded, setExpanded] = useState(null);

	const toggleExpand = (index) => {
		setExpanded(expanded === index ? null : index);
	};
	// Helper function
	const renderPoint = (point, pointIndex) => {
		if (Array.isArray(point)) {
			return (
				<li key={pointIndex} className='text-lg text-indigo-700 list-none'>
					<ul className='ml-6 list-disc space-y-1'>
						{point.map((subPoint, subPointIndex) => (
							<li key={subPointIndex} className='flex items-center text-base text-indigo-600'>
								<span className='mr-2'>•</span>
								{subPoint}
							</li>
						))}
					</ul>
				</li>
			);
		} else {
			return (
				<li key={pointIndex} className='text-lg text-indigo-700'>
					{point}
				</li>
			);
		}
	};

	return (
		<Main title={title || 'Instructions'} bgColor={'white'} width='80%' height='80%' onClick={onClick}>
			<Body>
				<div className='flex flex-col bg-gradient-to-r from-blue-100 to-indigo-200 p-6 rounded-3xl shadow-2xl'>
					{questions.map((item, index) => (
						<div key={index} className='bg-white rounded-xl shadow-xl overflow-hidden mb-6 transition-all duration-300'>
							<motion.div className='flex items-center justify-between cursor-pointer p-6 rounded-xl bg-gradient-to-r from-indigo-200 to-indigo-100 text-black' onClick={() => toggleExpand(index)} whileHover={{ scale: 1.03 }} transition={{ type: 'spring', stiffness: 300 }}>
								<p className='text-2xl  px-12 font-semibold'>
									<span className='mr-4'>{index + 1}.</span> {item.title}
								</p>
								<div className='text-white'>{expanded === index ? <FiChevronUp size={28} /> : <FiChevronDown size={28} />}</div>
							</motion.div>

							{expanded === index && (
								<motion.div initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} exit={{ opacity: 0, y: 20 }} transition={{ duration: 0.3 }} className='mt-4 p-6 bg-indigo-50 text-indigo-900 rounded-b-xl'>
									<div className='flex flex-row space-y-6'>
										<div className='w-2/3 '>
											{item.steps.map((step, stepIndex) => (
												<div key={stepIndex} className='mb-4'>
													<h4 className='text-xl font-semibold mb-2'>{step.stepTitle}</h4>
													<ul className='list-disc list-inside space-y-2'>{step.points.map((point, pointIndex) => renderPoint(point, pointIndex))}</ul>
												</div>
											))}
										</div>
										<div className='w-1/3'>
											{item.videoLink && (
												<div className='mt-6 w-full flex justify-center'>
													<div className='w-full max-w-md rounded-lg overflow-hidden shadow-lg'>
														<iframe width='100%' height='315' src={item.videoLink} title='YouTube video' frameBorder='0' allow='accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture' allowFullScreen></iframe>
													</div>
												</div>
											)}
										</div>
									</div>
								</motion.div>
							)}
						</div>
					))}
				</div>
			</Body>
		</Main>
	);
}

export default DocumentationComponent;
